import React from "react";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ isLoggedIn, title, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      component={props =>
        isLoggedIn ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} title={title} />
        )
      }
    />
  );
};

export default PublicRoute;
